import React from "react";
import { Tag } from "@chakra-ui/react";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { CourseLevel } from "@shared_types";
import PressableCard from "@/ui/PressableCard";
import { haptic } from "@/lib/haptic";
import { getLevelColor } from "../../styles/courseStyles";
import { getTagStyles } from "../../styles/cardStyles";
import CourseIcon from "./CourseIcon";

interface SquareCardProps {
  emoji: string | React.ReactNode;
  title: string;
  selected?: boolean;
  subtitle?: string;
  onClick?: () => void;
  completion?: number;
  level: CourseLevel;
  progress: number;
}

const CoursesCardRectangle: React.FC<SquareCardProps> = ({
  emoji,
  title,
  subtitle,
  selected = false,
  onClick,
  completion,
  level,
  progress,
}) => {
  const levelColor = getLevelColor(level);
  const centered = !completion;

  const handlePress = () => {
    haptic.soft();
    onClick?.();
  };

  return (
    <PressableCard
      onPress={handlePress}
      selected={selected}
      padding={16}
      containerStyle={{ flex: 1 }}
      style={{
        position: "relative",
        width: "100%",
        minHeight: 50,
        display: "flex",
        flexDirection: "column",
        justifyContent: centered ? "center" : "flex-start",
        alignItems: centered ? "center" : "flex-start",
        overflow: "hidden",
      }}
    >
      <div className="flex flex-row w-full h-full items-center justify-start text-center align-middle">
        <div className="text-3xl mr-3 flex-shrink-0 flex items-center">
          {typeof emoji === "string" ? (
            <CourseIcon emoji={emoji} size="large" />
          ) : (
            emoji
          )}
        </div>
        <div className="flex flex-col min-w-0 w-full items-start justify-start">
          <div className="font-bold text-lg w-full truncate text-start pr-[140px]">
            {title}
          </div>
          <div className="text-sm text-wrap text-start line-clamp-2 text-[var(--color-grey)]">
            {subtitle ? subtitle : ""}
          </div>
        </div>
      </div>
      <div className="flex absolute top-[10px] right-[12px] items-center gap-1">
        {progress >= 100 ? (
          <Tag {...getTagStyles("progress")} className="flex items-center gap-1">
            <HiMiniCheckBadge size={14} />
            100%
          </Tag>
        ) : progress > 0 ? (
          <Tag {...getTagStyles("progress")}>{`${progress}%`}</Tag>
        ) : (
          <Tag {...getTagStyles("level")} color={levelColor}>
            {level?.name?.toUpperCase()}
          </Tag>
        )}
      </div>
    </PressableCard>
  );
};

export default CoursesCardRectangle;
